import { useContext } from 'react';
import { createContext } from 'react';

import { ProductListPriceProps } from '../@types/ProductListPriceProps';

export const ProductListPriceContext = createContext<ProductListPriceProps>({} as ProductListPriceProps);

ProductListPriceContext.displayName = 'ProductListPrice';

const ProductListPriceProvider = (props: ProductListPriceProps) => (
	<ProductListPriceContext.Provider value={props}>{props.children}</ProductListPriceContext.Provider>
);

export const useProductListPrice = () => {
	const context = useContext(ProductListPriceContext);

	return context;
};

export default ProductListPriceProvider;
